/* eslint-disable no-await-in-loop */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment-timezone';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import Select from 'react-select';
import { Pagination } from '@material-ui/lab';
import {
  Grid,
  Box,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  Menu,
  MenuItem,
  Dialog,
  TableCell,
  TextField
} from '@material-ui/core';
import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import api from '../../../service/axios/api';
import Button from '../../button/MyButton';
import FlashContext from '../../contexts/FlashContext';

import SelectOptions from './SelectOptions1';

import './tableOrder.css';

const useStyles = makeStyles(theme =>
  createStyles({
    textNotification: {
      textAlign: 'center',
      fontFamily: 'Open Sans',
      fontSize: 14,
      fontWeight: 'bold',
      lineHeight: 'auto',
      color: '#707070',
      '&:hover': {
        backgroundColor: '#41b490',
        color: '#fff',
      },
    },
  }),
);

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#005D9F',
    fontFamily: 'Open Sans',
    color: theme.palette.common.white,
  },
  body: {
    color: '#717171',
    fontFamily: 'Open Sans',
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: '#41b490',
      color: '#41b490',
    },
  },
}))(TableRow);

const options = [
  {
    label: '25',
    value: 25,
  },
  {
    label: '50',
    value: 50,
  },
  {
    label: '100',
    value: 100,
  },
];

const EnhancedTableHead = props => {
  const { t: header } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell component="th">
          {header('OrderInfo.table.orderNumber')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {header('OrderInfo.table.nf')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {header('OrderInfo.table.slip')}
        </StyledTableCell>
        <StyledTableCell component="th">
          {header('OrderInfo.table.reason')}
        </StyledTableCell>
        <StyledTableCell component="th" align="right">
          {/* <MoreVertIcon /> */}
        </StyledTableCell>
      </TableRow>
    </TableHead>
  );
};

export default function EnhancedTable({
  orders,
  totalPages,
  setPage,
  page,
  itens,
  setItens,
  setStatus,
  product,
  setProduct,
  setOrderBy,
  chipData,
  setChipData,
  find,
}) {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);
  const [selected, setSelected] = React.useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [menuOptions, setMenuOptions] = useState(null);
  const [reason, setReason] = useState("")

  const handleUpdateReason = async (row) => {
    if(reason.length <= 0){
      notifyError(t('OrderInfo.dialog.addReason'))
      return
    }
    try {
      const res = await api.order.editOrder(row.id, row.name, row.comments, row.payment_date, row.is_invoicer_legal_entity, "", reason)
      if(res.code === "API_RES_SUCCESS"){
        notifySuccess(t('OrderInfo.dialog.success'))
        find()
      } else {
        notifyError(t('OrderInfo.dialog.error'))
      }
    } catch (error) {
      notifyError(error.message || t('OrderInfo.dialog.error'))
    } finally {
      setOpenEdit(false)
      setReason("")
    }
    
  }

  const handleMenu = (row, event) => {
    setMenuOptions(row);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [rows, setRows] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    const listOrder = [];
    // console.log(orders)
    orders.forEach(or => {
      listOrder.push({
        id: or.id,
        name: or.order_name,
        nf: or.gcs_pdf && (
          <div
            style={{ cursor: 'pointer', color: 'blue' }}
            onClick={() => window.open(or.gcs_pdf, '_blank')}
          >
            {or.invoice_number}
          </div>
        ),
        pgto:
          or.date_payment && moment.utc(or.date_payment).format('DD/MM/yyyy'),
        rs: or.company_name,
        pd: or.order_number,
        product: or.product_type,
        vlr: `R$ ${or.total || or.provision}`,
        status: or.status,
        db: or.debitNotes,
        all: or,
        invoiceNumber: or.invoice_number,
        created: or.created_at,
        contractid: or.contractid,
        cancelation_obs: or.cancelation_obs,
        payment_slips: or.payment_slips
      });
    });
    setRows(listOrder);
  }, [orders]);

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setSelected([]);
    setPage(newPage);
  };

  return (
    <>
      {/* <Grid item> */}
      <SelectOptions
        setStatus={setStatus}
        setChipData={setChipData}
        chipData={chipData}
        find={find}
        setOrderBy={setOrderBy}
        product={product}
        setProduct={setProduct}
        setSelectec={setSelected}
      />
      {/* </Grid> */}
      <Box sx={{ width: '100%' }}>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={rows.length}
                handleMenu={handleMenu}
              />
              <TableBody>
                {rows ? (
                  rows.length > 0 ? (
                    rows.map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <StyledTableRow tabIndex={-1} key={row.id}>
                          <StyledTableCell>{row.pd}</StyledTableCell>
                          <StyledTableCell
                            component="th"
                            id={labelId}
                            scope="row"
                          >
                            <p
                              style={{ cursor: 'pointer', color: 'blue' }}
                              className="modal-box-body-value-label"
                            >
                              {row.nf}
                            </p>
                            {api.currentUser?.user?.role?.id !== '1'
                              ? row.db &&
                              row.db.length > 0 &&
                              row.db.map(r => {
                                return (
                                  <p
                                    key={r.nd_number}
                                    style={{
                                      cursor: 'pointer',
                                      color: 'blue',
                                    }}
                                    className="modal-box-body-value-label"
                                    onClick={() => window.open(r.gcs_pdf)}
                                  >
                                    {r.nd_number}
                                  </p>
                                );
                              })
                              : api.currentUser?.user?.role?.id !== '3' &&
                              row.db &&
                              row.db.length > 0 &&
                              row.db.map(r => {
                                if (r.gcs_pdf) {
                                  return (
                                    <p
                                      key={r.nd_number}
                                      style={{
                                        cursor: 'pointer',
                                        color: 'blue',
                                      }}
                                      className="modal-box-body-value-label"
                                      onClick={() => window.open(r.gcs_pdf)}
                                    >
                                      {r.nd_number}
                                    </p>
                                  );
                                }
                              })}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            id={labelId}
                            scope="row"
                          >
                            {row.payment_slips && row.payment_slips.length > 0 && (
                              row.payment_slips.map((slip, i) => (
                                <p
                                  key={i}
                                  style={{ cursor: 'pointer', color: 'blue' }}
                                  onClick={() => window.open(slip.link, '_blank')}
                                >
                                  {slip.type === 'invoice' ? t('OrderInfo.table.viewSlip') : t('OrderInfo.table.viewDebitSlip')}
                                </p>
                              ))
                              // <p
                              //   style={{ cursor: 'pointer', color: 'blue' }}
                              //   className="modal-box-body-value-label"
                              //   onClick={() => window.open(row.payment_slip_link, '_blank')}
                              // >
                              //   {t('OrderInfo.table.viewSlip')}
                              // </p>
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            id={labelId}
                            scope="row"
                          >
                            <p
                              className="modal-box-body-value-label"
                            >
                              {row.cancelation_obs || ""}
                            </p>
                            
                          </StyledTableCell>
                          <StyledTableCell component="th" align="right">
                            {row.cancelation_obs && (
                              <MoreVertIcon
                                onClick={e => handleMenu(row, e)}
                                fontSize="small"
                                style={{ cursor: 'pointer' }}
                              />
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={9} align="center">
                        {t('Order.table.noResult')}
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={9} align="center" />
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Menu
            id="menu-appbar"
            style={{ borderRadius: '25px' }}
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              className={classes.textNotification}
              onClick={() => setOpenEdit(true)}
            >
              {t('OrderInfo.table.edit')}
            </MenuItem>
          </Menu>
        </Paper>
      </Box>
      <Grid
        container
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 15,
        }}
        spacing={2}
        direction="row"
      >
        <Grid item>
          <Select
            className="basic-single"
            classNamePrefix="select"
            placeholder="Itens"
            value={itens}
            onChange={setItens}
            options={options}
          />
        </Grid>
        <Grid item>
          <Pagination
            size="large"
            count={totalPages}
            page={page}
            onChange={handleChangePage}
            variant="outlined"
            shape="rounded"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{
          justifyContent: 'end',
          padding: 40,
        }}
      />
      <Dialog
        onClose={() => setOpenEdit(!openEdit)}
        open={openEdit}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="simple-dialog-title">
          {t('OrderInfo.dialog.title')}
        </DialogTitle>
        <DialogContent style={{
          width: '100%'
        }}>
          <DialogContentText id="alert-dialog-description">
            {t('OrderInfo.dialog.message')}
          </DialogContentText>
          <TextField
            // margin="dense"
            placeholder={t('OrderInfo.dialog.placeholder')}
            type="text"
            fullWidth
            variant="outlined"
            multiline
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <h6
            style={{
              cursor: 'pointer',
              color: '#657588',
              fontWeight: 'bold',
              fontFamily: 'Open Sans',
              marginTop: 5,
            }}
            onClick={() => setOpenEdit(false)}
          >
            {t('Order.table.duplicateCancelBtn')}
          </h6>
          <Button
            style={{ height: 40 }}
            onClick={() => handleUpdateReason(menuOptions)}
            color="primary"
            variant="contained"
            label={t('OrderInfo.dialog.finalize')}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
